import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const Mic = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox='0 0 25 24' xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.17 6.25c0-1.98-1.64-3.6-3.67-3.6a3.63 3.63 0 0 0-3.67 3.6V12c0 1.98 1.64 3.6 3.67 3.6 2.03 0 3.67-1.62 3.67-3.6V6.25ZM12.5 18.47v2.87" />
      <path d="M19.07 12.72a6.43 6.43 0 0 1-2.17 4.08 6.7 6.7 0 0 1-8.8 0 6.43 6.43 0 0 1-2.17-4.08" />
    </g>
  </svg>);
export default Mic;